import React from "react"
import styled from "styled-components"
import CTABg from "../../images/find-section.png"
import ProductSearch from "../AlgoliaSearch/ProductSearch"
import BreakpointUp from "../Media/BreakpointUp"

const GridWrap = styled.div`
  position: relative;
  background: #0059b2;
  padding: 40px 0;
  ${BreakpointUp.md`
		padding:60px 0;
	`}
  ${BreakpointUp.xl`
		padding:100px 0;
	`}
	${BreakpointUp.xxl`
		padding:130px 0;
	`}
`
const GridRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  justify-content: space-between;
  align-items: center;
`
const GridLeft = styled.div`
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  ${BreakpointUp.lg`
		flex: 0 0 50%;
    	max-width: 50%;
	`}
`
const GridRight = styled.div`
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  ${BreakpointUp.lg`
		flex: 0 0 41.666667%;
    	max-width: 41.666667%;
	`}
`
const TextWrap = styled.div`
  & strong,
  & h2 {
    color: #fff;
  }
`

const CallWrap = styled.div`
  margin-bottom:0;
  & .ais-SearchBox-form {
    width: 100%;
    max-width: 430px;
    margin-bottom: 15px;
    background: #0059b2;
    font-family: 'UniNeueBold', sans-serif;
    font-weight: 400;
    border-radius: 8px;
    border: 1px solid rgba(165, 205, 240, 0.6);
    font-size: 16px;
    line-height: 40px;
    padding: 0 15px;
    ${BreakpointUp.sm`
      font-size: 18px;
      line-height: 60px;
      padding: 0 20px;
    `}
    ${BreakpointUp.lg`
      font-size: 20px;
      line-height: 68px;
      padding: 0 25px;
    `}
    & input {
      background: #0059b2;
      border: 0;
      color: white;
    }
    ::placeholder {
      color: #fff;
      opacity: 1;
    }

    :-ms-input-placeholder {
      color: #fff;
    }

    ::-ms-input-placeholder {
      color: #fff;
    }
  }
`

const BackgroundImage = styled.div`
  background: url(${(props) => props.bg});
  background-size: cover;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0.1;
`

class SearchCTA extends React.Component {
  render() {
    const { title, serviceName } = this.props
    const temp = serviceName.replace(/[^\w\s]+/gi, " ").replace(/  +/g, " ")
    const serviceUrl = temp.split(" ").join("-").toLowerCase()    
    return (
      <GridWrap>
        <BackgroundImage bg={CTABg} />
        <div className="container">
          <GridRow>
            <GridLeft>
              <TextWrap>
                <strong>Find Your</strong>
                <h2>{title}</h2>
              </TextWrap>
            </GridLeft>
            <GridRight>
              <CallWrap>
                <ProductSearch
                  placeHolder="Search the Part You Are Looking"
                  type={serviceUrl}
                />
              </CallWrap>
            </GridRight>
          </GridRow>
        </div>
      </GridWrap>
    )
  }
}

export default SearchCTA
